// extracted by mini-css-extract-plugin
export default {"tasks":"stylesBarraTitulo_tasks__HX64p"};